export default "__VITE_ASSET__BcUZKvty__"